import axios from "axios";
import { clientConfig } from "./client-config";

export const SearchPropertiesService = {
  getAll(project: string) {
    return axios
      .post(`${clientConfig.apiUrl}/propiedades/get-all`, {
        project,
      })
      .then((response) => response.data);
  },

  search(project: string, filters: any) {
    return axios
      .post(`${clientConfig.apiUrl}/propiedades/buscar`, {
        project,
        filters,
      })
      .then((response) => response.data)
      .catch(function (error) {
        console.log(error);
      });
  },

  // getAmbientesOptions(ambientesOpts, unidades) {
  //   const unidadesDisponibles = [
  //     ...new Set(unidades.map(({ ambientes }) => ambientes)),
  //   ];

  //   return ambientesOpts.filter(
  //     (x) =>
  //       unidadesDisponibles.find((u) => u === x.value) === x.value ||
  //       x.value === "all"
  //   );
  // },

  getFilteredOptions(
    opts,
    unidades,
    nroAmbientes,
    key: "exterior" | "orientacion"
  ) {
    const unidadesDisponibles = [
      ...new Set(
        unidades
          ?.filter(({ ambientes }) =>
            nroAmbientes === "all" || !nroAmbientes
              ? true
              : ambientes
                  .split(",")
                  .map((item: any) => item.trim())
                  .includes(`${nroAmbientes}`.trim())
          )
          .map((u) => u[key])
      ),
    ];

    return opts.filter(
      (x) =>
        unidadesDisponibles.find(
          (u: any) => u.toLowerCase() === x.value.toLowerCase()
        ) || x.value === "all"
    );
  },
};
